import {ChatroomCard} from './ChatroomCard';
export default ChatroomCard;
